import { render, staticRenderFns } from "./MobileMenuGroup.vue?vue&type=template&id=0bbfdef4&"
import script from "./MobileMenuGroup.vue?vue&type=script&lang=js&"
export * from "./MobileMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./MobileMenuGroup.vue?vue&type=style&index=0&id=0bbfdef4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports